module.exports = __webpack_public_path__ + "img/home_bg.ba17a3e1.svg";